module.exports = __webpack_public_path__ + "static/img/r5-text.daf74bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/mobile/role/r5-text.png
// module id = l0TT
// module chunks = 0